export enum DelistingQueries {
  DelistingTable = 'delistingTable',
  SearchDelistingElement = 'searchDelistingElement',
}
